import { AnalisisLaboratorioResponse } from "../../../../modulos/fertilizacion/response/AnalisisLaboratorioResponse";
import { ClienteFincaLoteResponse } from "../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { formatFechaCorta } from "../../../../utils/fechaUtils";
import { tipoAnalisisLabel } from "../../../../utils/fertilizacionUtils";
import { BaseFullScreenModalRender } from "../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../definitions/IConnectRender";
import { FertilizacionDiagnosticoRender } from "../detail/FertilizacionDiagnosticoRender";

/** Modal a pantalla completa con el diagnóstico de un análisis: KPIs + detalle
 *  por grupo/lote. Solo lectura — se abre desde "Analizar Finca" en el sidebar,
 *  y únicamente cuando el análisis ya tiene recomendación generada. Lo que en el
 *  mockup vivía en el topbar de la pantalla va acá en la barra del modal. */
export class FertilizacionDiagnosticoModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "fertilizacionDiagnosticoModal";

  /**
   * @param _analisis Análisis a diagnosticar (con recomendación generada).
   * @param _lotes    Lotes de la finca (nombre/cultivo/área de cada registro).
   */
  constructor(
    private readonly _analisis: AnalisisLaboratorioResponse,
    private readonly _lotes: ClienteFincaLoteResponse[],
  ) {
    super();
  }

  protected get title(): string {
    return "Diagnóstico de suelo";
  }

  /** Finca · fecha del análisis · tipo. */
  protected get subtitle(): string | undefined {
    const finca = serviceProvider.getFincaSelectedService().get()?.nombreFinca;
    const fecha = formatFechaCorta(this._analisis.fechaAnalisis);
    const tipo = tipoAnalisisLabel(this._analisis.tipoAnalisis);
    return [finca, fecha, tipo].filter(Boolean).join(" · ");
  }

  protected getContent(): IConnectRender {
    return new FertilizacionDiagnosticoRender(this._analisis, this._lotes);
  }
}
